module.exports = __webpack_public_path__ + "img/Z82_12.abf00f1f.jpg";